export default {
  SET_RATE_PLAN_POLICIES (state, rate_plan_policies) {
    state.rate_plan_policies = rate_plan_policies
  },
  REMOVE_RECORD (state, itemId) {
    const ratePlanPolicyIndex = state.rate_plan_policies.findIndex((u) => u.id === itemId)
    state.rate_plan_policies.splice(ratePlanPolicyIndex, 1)
  }
}
